// extracted by mini-css-extract-plugin
export var loaderText = "VanillaMapContainer-module--loaderText--f7273";
export var loaderWrapper = "VanillaMapContainer-module--loaderWrapper--65fbf";
export var mapContainer = "VanillaMapContainer-module--mapContainer--3f9ab";
export var mapWrapper = "VanillaMapContainer-module--mapWrapper--68f22";